__turbopack_context__.v({
  "form-head": "ukwP0q_form-head",
  "has-bg": "ukwP0q_has-bg",
  "placeholder": "ukwP0q_placeholder",
});
